import { globalState } from "@/state";
import { ElMessageBox, ElMessage } from "element-plus";
export default {
  name: "HomePage",
  data() {
    return {
      toolList: [],
      categoryList: [],

      currentFilter: "lastest",
      rankType: "download",
      rankDownloadList: [],
      rankRateList: [],
      subList: [],
    };
  },
  computed: {
    topDownloadedTools() {
      return [...this.rankDownloadList].slice(0, 3);
    },
    topRatedTools() {
      return [...this.rankRateList].slice(0, 3);
    },
    user() {
      return this.$store.state.user;
    },
    isLogin() {
      return this.user && this.user.uid;
    },
  },
  created() {
    this.getCategory();
  },
  methods: {
    checkLogin(router) {
      if (!this.isLogin) {
        ElMessageBox.confirm("需要使用当前功能，请先登录账号", "登录", {
          confirmButtonText: "登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(() => {});
        return;
      }

      this.$axios({
        url: "aitool/user/checklogin",
      }).then((res) => {
        if (res.code == 200) {
          this.$router.push(router);
        }
      });
    },
    downloadAction(tool) {
      if (!this.isLogin) {
        this.$router.push("/login");
        return;
      }

      ElMessageBox.confirm(
        `确认消耗：2积分下载工具《${tool.title}》`,
        "下载工具",
        {
          confirmButtonText: "下载",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          // 发起下载请求
          this.$axios({
            url: "aitool/download/" + tool.id, // 注意：这里建议检查URL拼接是否正确，通常需要 / 分隔，比如 "aitool/download/" + tool.id
          })
            .then(async (res) => {
              if (res.code == 200) {
                const fileUrl = res.data.file;
                // 调用下载函数
                this.downloadFile(fileUrl, tool.title);

                // 提示下载成功
                ElMessage({
                  message: "下载已开始",
                  type: "success",
                });
              } else {
                ElMessage({
                  message: res.msg || "下载失败", // 注意：你原代码是 res.msh，应该是笔误，修正为 res.msg
                  type: "error",
                });
              }
            })
            .catch((err) => {
              // 捕获请求异常
              ElMessage({
                message: "网络错误，下载失败",
                type: "error",
              });
              console.error("下载请求失败：", err);
            });
        })
        .catch(() => {
          // 用户取消下载的提示（可选）
          ElMessage({
            message: "已取消下载",
            type: "info",
          });
        });
    },

    // 封装文件下载函数
    downloadFile(fileUrl, fileName) {
      // 创建a标签
      const link = document.createElement("a");
      // 设置下载地址
      link.href = fileUrl;
      // 设置下载文件名（可选，若无则使用服务器返回的文件名）
      if (fileName) {
        link.download = fileName;
      }
      // 隐藏a标签
      link.style.display = "none";
      // 添加到DOM
      document.body.appendChild(link);
      // 触发点击
      link.click();
      // 移除a标签
      document.body.removeChild(link);
    },
    getCategory() {
      this.$axios({
        url: "subinfo/list",
      }).then((res) => {
        this.subList = res.data;
      });
      this.$axios({
        url: "category/list/count",
      }).then(async (res) => {
        this.categoryList = res.data;
        this.getToolsList(this.currentFilter);
        await this.getRankDownload();
      });
    },
    async getRankDownload() {
      var data = await this.$aesEncrypt({
        timeType: "all",
        category: "all",
      });
      var uid = "";
      if (this.isLogin) {
        uid = this.user.uid;
      }
      this.$axios({
        url: "aitool/rank/month/download?uid=" + uid,
        method: "POST",
        data: {
          data: data,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.rankDownloadList = res.data;
        }
      });

      this.$axios({
        url: "aitool/rank/month/rating?uid=" + uid,
        method: "POST",
        data: {
          data: data,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.rankRateList = res.data;
        }
      });
    },

    getToolsList(type) {
      this.currentFilter = type;
      var uid = "";
      if (this.isLogin) {
        uid = this.user.uid;
      }
      this.$axios({
        url: `aitool/list/home/${type}?uid=${uid}`,
      }).then((res) => {
        this.toolList = res.data;
      });
    },
    openToolDetail(tool) {
      globalState.openModal(tool.id, this.categoryList);
    },
    getCategoryName(id) {
      const category = this.categoryList.find((c) => c.id === id);
      return category ? category.title : "未知";
    },

    getSubName(id) {
      var sub = this.subList.find((c) => c.id === id);
      return sub ? sub.title : "";
    },
    formatNumber(num) {
      if (num >= 1000) {
        return (num / 1000).toFixed(1) + "k";
      }
      return num;
    },
    favAction(tool) {
      if (!this.isLogin) {
        ElMessageBox.confirm("使用收藏功能，请先登录账号", "登录", {
          confirmButtonText: "登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(() => {});
      }
      if (tool.isFav) {
        tool.isFav = false;
        //取消
        this.$axios({
          url: "aitool/action/fav/" + tool.id,
          method: "DELETE",
        }).then((res) => {
          if (res.code != 200) {
            ElMessage.error(res.msg);
          }
        });
      } else {
        tool.isFav = true;
        this.$axios({
          url: "aitool/action/fav/" + tool.id,
        }).then((res) => {
          if (res.code != 200) {
            ElMessage.error(res.msg);
          }
        });
      }
    },

    zanAction(tool) {
      if (!this.isLogin) {
        ElMessageBox.confirm("使用点赞功能，请先登录账号", "登录", {
          confirmButtonText: "登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(() => {});
      }
      if (tool.isZan) {
        tool.isZan = false;
        //取消
        this.$axios({
          url: "aitool/action/zan/" + tool.id,
          method: "DELETE",
        }).then((res) => {
          if (res.code != 200) {
            ElMessage.error(res.msg);
          }
        });
      } else {
        tool.isZan = true;
        this.$axios({
          url: "aitool/action/zan/" + tool.id,
        }).then((res) => {
          if (res.code != 200) {
            ElMessage.error(res.msg);
          }
        });
      }
    },
  },
};
